let systemConfig = window.systemConfig
export default {
  // 項目任務
  project_task: {
    project: '項目協作',
    projectName: '項目名稱',
    projectStatus: '項目狀態',
    addProject: '新建項目',
    inputProjectName25: '請輸入項目名稱，限25個字',
    inputProjectName500: '請輸入內容，限500個字',
    projectDescription: '項目描述',
    placeOnFilePro: '歸檔項目',
    nowProjectStatus: '當前項目狀態',
    projectProgress: '項目進度',
    genjuTaskProgress: '根據任務完成進度自動計算',
    handInput: '手動填寫',
    visibleRange: '可見範圍',
    notPublic: '不公開:只有加入的人員才能看見此項目',
    public: '公開:企業所有人員都能看見此項目',
    notPublic1: '不公開',
    public1: '公開',
    personInCharge: '負責人',
    operationAuth: '操作權限',
    useTaskRoleCustom: '可對任務內的角色權限進行自定義',
    addTask: '新增任務',
    projectCollaboration: '項目協作',
    systemMessage: '系統消息提示',
    projectProMustFill: '項目進度為必填的正整數',
    selectSpecificNumber: '請選擇具體時間',
    sureDelProject: '確定要刪除該項目嗎?',
    role: '角色',
    task: '任務',
    executor: '執行人',
    creater: '創建人',
    setDeadline: '設置截止時間',
    selectDeadlinetime: '請選擇截止時間',
    deadlineMustinteger: '截止時間必須是整數',
    sureMovePeopleForPro: '確定要轉移項目負責人嗎?轉移後您將被移出該項目',
    remindSet: '提醒設置',
    deadlineTimeRmind: '在任務截止前，通過以下方式提醒任務執行人',
    taskName: '任務名稱',
    state: '狀態',
    priority: '優先級',
    selectPriority: '選擇優先級',
    tagUseMoveInfo: '該標簽在當前項目已被任務所使用，移除後本項目內所有任務將移除該標簽',
    startTime: '開始時間',
    deadlineTime: '截止時間',
    endTime: '結束時間',
    createTime: '創建時間',
    lookTheTask: '查看該任務',
    addGroup: '添加分組',
    editGroup: '編輯分組',
    delGroup: '刪除分組',
    allProject: '全部項目',
    allTask: '全部任務',
    myResponsible: '我負責的',
    myJoin: '我參與的',
    myCreated: '我創建的',
    haveInHand: '進行中',
    notBegin: '未開始',
    isStop: '已暫停',
    isCompleted: '已完成',
    forInspection: '待檢驗',
    inspectionReject: '檢驗駁回',
    stop: '暫停',
    stopPro: '暫停項目',
    enable: '啟用',
    enablePro: '啟用項目',
    del: '刪除',
    delPro: '刪除項目',
    projectNowProre: '項目當前進度',
    statusProject1:
      '如果此項目已經結束了，妳可以歸檔它，歸檔後項目將不允許再次編輯任務，只允許成員查看',
    statusProject2:
      '如果此項目已經不再進行了，妳可以暫停它，暫停後項目內任務將不允許再次操作，但還可以重新啟動',
    statusProject3: '如果此項目已經暫停或歸檔了，妳可以再次啟用它，啟用後項目內任務可以再次操作',
    statusProject4: '如果此項目已經不再需要了，妳可以刪除它，刪除後該項目下所有任務同時被刪除',
    completedTask: '完成任務',
    overdue: '超期',
    overdueNotStarted: '超期未開始',
    clickChooseTIme: '點擊選擇時間',
    deadlineDate: '截止日期',
    endDate: '結束日期',
    startDate: '開始日期',
    clickChooseTemplate: '選擇模板',
    groupName: '分組名稱',
    auth: '權限',
    start: '開 始',
    companyOwnerVisible: '企業所有人員可見',
    projectMemberVisible: '僅項目成員可見',
    projectGroup: '項目分組',
    projectName25: '項目名稱不能大於25個字',
    deadTimeMaxStartTime: '截止時間必須大於開始時間',
    newBuildtGroup: '新建分組',
    pleaseSelectDate: '請選擇日期',
    pleaseSelectpersoanl: '請選擇負責人',
    groupNameRequire: '分組名稱必填',
    groupNameNotRepeat: '分組名稱不能重復',
    isDeleteGroup: '確定要刪除該項目分組嗎?',
    projectDesc500: '項目描述必須在500字以內',
    selectTiemMinNowTiem: '所選時間小於當前時間，請確認是否創建?',
    selectTempalte: '選擇模版',
    myTempalte: '我的模版',
    allTempalte: '所有模版',
    commonTempalte: '通用模板',
    afterService: '售後服務',
    productDev: '產品研發',
    administrativePersonnel: '行政人事',
    marketingManagement: '市場營銷',
    previewProjectTemplate: '預覽項目模版',
    useThisTemplate: '使用該模板',
    listView: '列表視圖',
    kanbanView: '看板視圖',
    calendarView: '日歷視圖',
    tableView: '表格視圖',
    pleaseInputTaskname: '請輸入任務名稱',
    activationReason: '激活原因',
    isActivateThisTask: '確定要激活此任務嗎?',
    isCompleteThisTask: '確定要完成此任務嗎?',
    createdSubtaskList: '創建子任務列表',
    subTaskList: '創建子任務列表',
    taskList: '任務列表',
    createdTaskGroup: '創建任務分組',
    taskGroup: '任務分組',
    quoteTemplate: '引用模版',
    addTaskList: '新增任務列表',
    taskListName: '任務列表名稱',
    taskGroupName: '任務分組名稱',
    usePersonnel: '使用人員',
    preview: '預覽',
    workflow: '工作流',
    noTemplateSelect: '暫無模版可選',
    taskGroupNameInfo1: '任務分組名稱必需在25字以內，且必填',
    listNameInfo1: '列表名稱必需在25字以內，且必填',
    openTaskDetails: '打開任務詳情',
    subClass: '下級分類',
    levelClassOrTask: '同級分類或任務',
    rename: '重命名',
    batchOperation: '批量操作',
    markMilestone: '標記裏程碑',
    cancelMilestone: '取消裏程碑',
    taskStopCannotOperation: '任務暫停，不能進行操作',
    taskCompleteCannotOperation: '任務已經完成,不能進行操作',
    taskTestCannotOperation: '任務待檢驗,不能進行操作',
    InputBoxCannotEmpty: '輸入框不能為空',
    cannotCreateNewTask: '不能新建子任務',
    placeOnFile: '歸檔',
    projectConnotOperation1: '項目已歸檔,不能進行其他操作',
    projectConnotOperation2: '項目已暫停,不能進行其他操作',
    taskUnderConnotAddClass: '任務下不能新建分類',
    pleaseFillACtiveReason: '請填寫激活原因',
    pleaseFillEditReason: '請填寫編輯原因',
    pleaseFillClassName: '請輸入分類名稱',
    classDontAgaInput: '要刪除的分類名稱不匹配,請重新輸入',
    activeReason: '激活原因',
    editReason: '編輯原因',
    stopReason: '暫停原因',
    haveSubtask: '有子任務尚為完成',
    retract: '收起',
    addPerformer: '收起',
    projectLeader: '項目負責人',
    notActive: '未激活',
    delClass: '刪除分類',
    allShare: '所有分享',
    myShare: '我的分享',
    pleaseSelectClass: '請選擇分類',
    inputDelClassName: '請輸入要刪除的分類名稱',
    chooseClassMove: '選擇需要將此分類移動到的位置',
    chooseClassCopy: '選擇需要將此任務復制到的位置',
    tipsTask1: '提示：任務、協作人、子任務將被復制',
    selectExecutor: '請選擇執行人',
    settingTaskRemind: '設置任務提醒',
    remindType: '提醒類型',
    customRemind: '自定義提醒',
    deadlineTimeRemind: '截止時間提醒',
    beforeDeadlineTime: '截止前',
    minute: '分鐘',
    hour: '小時',
    day: '天',
    hour1: '時',
    minute1: '分',
    second: '秒',
    remindTime: '提醒時間',
    reminder: '被提醒人',
    RemindMode: '提醒方式',
    qixin: systemConfig && systemConfig.qixin ? systemConfig.qixin.zh_TW : '企信',
    customRepeatTask: '自定義重復任務',
    repeat: '重復',
    useDay: '按天',
    useWeek: '按周',
    useMonth: '按月',
    neverRepeat: '從不重復',
    frequency: '頻率',
    week: '周',
    month: '月',
    clickChoose: '點擊選擇',
    over: '結束',
    never: '永不',
    cishu: '次數',
    date: '日期',
    happen: '發生',
    tipsTask2: '提示：成員必須綁定企業微信、釘釘或郵箱，才能收到提醒',
    settingRepeatTask: '設置重復任務',
    moveTask: '移動任務',
    copyTask: '復制任務',
    delTask: '刪除任務',
    checkOpinion: '校驗意見',
    className: '分類名稱',
    belongToTask: '屬於任務',
    parentTaskName: '父任務名稱',
    check: '校驗',
    subTask: '子任務',
    subTaskName: '子任務名稱',
    addSubTask: '添加子任務',
    quote: '引用',
    byQuote: '被引用',
    onlyParticipantsVisible: '僅參與者可見',
    collaborator: '協作人',
    projectMembers: '項目成員',
    activation: '激活',
    personalTask: '個人任務',
    dianzang: '點贊',
    noDianzang: '暫無點贊',
    editMemberComplete: '修改成員成功',
    sureDelShare: '確定要刪除分享嗎?',
    shareRequ: '分享內容為必填',
    title100: '標題需在100字以內必填',
    moveTaskComplete: '移動任務成功',
    copyTaskComplete: '復制任務成功',
    delAllsubtaskDel: '刪除任務後，所有子任務也會被刪除',
    subDealtimeMinParentTime: '子任務截止時間必須小於主任務截止時間',
    sureDelSubtask: '確定刪除子任務嗎?',
    sureCancelAssociation: '確定取消關聯嗎?',
    cancelAssociationComplete: '取消關聯成功',
    sureActive: '確認要激活嗎?',
    sureCompleteTask: '確定完成該任務嗎?',
    pleaseFillInCheckReason: '請填寫檢驗編輯原因',
    subtaskName500: '子任務名稱不能超過500個字,且為必填',
    pleaseChoosePer: '請選擇人員',
    choosePer: '選擇人員',
    sureDelCollaborator: '確定刪除該協作人嗎',
    systemApplication: '系統應用',
    name: '名稱',
    addRemindPerson: '添加被提醒人',
    pleaseFillInFrequency: '請填寫頻率',
    pleaseFillInHappenCishu: '請填寫發生次數',
    dataIncomplete: '數據不完整',
    frequencyInteger: '頻率必須為正整數',
    happenCishuInteger: '發生次數須為正整數',
    pleaseChooseDate: '請選擇日期',
    setTimeLessNow: '設置時間小於當前時間',
    pleaseRemindTime: '請選擇提醒時間',
    pleaseDeadTime: '請選擇截止前時間',
    pleaseRemindType: '請選擇提醒方式',
    pleaseReminder: '請選擇被提醒人',
    customFields: '自定義字段',
    currentState: '當前狀態',
    checker: '校驗人',
    selectPic: '選擇圖片',
    addTag: '添加標簽',
    tag: '標簽',
    relation: '關聯',
    relationTiggerAddTask: '關聯觸發新建任務的數據',
    addRelation: '添加關聯',
    cancelRelation: '取消關聯',
    describe: '描述',
    addMoreFields: '添加更多字段',
    addDescribe: '添加描述',
    enclosure: '附件',
    addEnclosure: '添加附件',
    selectRelation: '選擇關聯關系',
    firstSelectExecutor: '請優先選擇執行人',
    moveMember: '移除成員',
    editProjectAuth: '修改項目權限',
    editProjectRole: '修改項目角色',
    starMarkProject: '星標項目',
    projectShare: '分享',
    projectShareTo: '分享給',
    top: '置頂',
    cancelTop: '取消置頂',
    notAddShare: '您還沒有添加分享',
    projectGuideMap: '項目導圖',
    timeControl: '時間管控',
    baseSetting: '基本設置',
    projectTag: '項目標簽',
    customManage: '自定義管理',
    automationManage: '自動化管理',
    exportProjectTask: '導出項目任務',
    saveProjectTemplate: '保存為項目模板',
    baseInfo: '基本信息',
    statusSet: '狀態設置',
    ruleSet: '權限設置',
    taskRemind: '任務提醒',
    taskSet: '任務設置',
    taskActiveInput: '任務重新激活填寫激活原因',
    updateDaedlineTimeInput: '更改截止時間填寫修改原因',
    Appearance: '外觀',
    tagManage: '標簽管理',
    projectSet: '項目設置',
    generalTasks: '總任務',
    projectDynamics: '項目動態',
    templateName: '模板名稱',
    mamzuContion1: '滿足條件的記錄自動執行設定的業務流程',
    module: '模塊',
    ruleName: '規則名稱',
    triggerEvent: '觸發事件',
    projectAutomation: '協作自動化',
    sureMoveProjectMember: '確定要移除該項目成員嗎?',
    nowProjectUnder: '該項目成員下還存在需要執行的任務,請在下方選擇任務交接人，交接後可移除成功',
    handoverPerson: '交接人',
    SelecthandoverPerson: '請選擇轉交人',
    customWorkbench: '自定義工作臺',
    timeWorkbench: '時間工作臺',
    sureDelProMember: '確定要刪除該項目成員嗎?',
    sureDelThisRule: '確定要刪除該規則嗎?',
    projectTask: '項目任務',
    automatchTrigger1: '在新建記錄保存後',
    automatchTrigger2: '在編輯記錄保存後',
    automatchTrigger3: '在新建或編輯記錄保存後',
    automatchTrigger4: '被完成',
    automatchTrigger5: '被移動',
    automatchTrigger6: '被重新激活',
    automatchTrigger10: '被刪除後',
    automatchTrigger7: '在字段自動更新後',
    automatchTrigger8: '在刪除記錄後',
    automatchTrigger9: '在領取記錄後（公海池）',
    automatchTrigger11: '定時觸發',
    allChecked: '全選',
    newBuildClass: '新建分類',
    addExecutor: '添加執行人',
    assignTo: '分配給',
    pleaseSelectAssignor: '請選擇分配人',
    nameIsNotEmpty: '名稱不能為空',
    delList: '刪除列表',
    inputDelListName: '請輸入要刪除的列表名稱',
    inputListNameAtypism: '輸入的列表名稱不壹致',
    editFolder: '編輯文件夾',
    delFolder: '刪除文件夾',
    notAddFolder: '您還沒有添加文件',
    addFolder: '添加文件夾',
    nowAddFolder: '現在就添加',
    folderName: '文件夾名稱',
    folderSetting: '文件夾設置',
    addSubFolder: '添加子文件夾',
    addFile: '添加文件',
    sureDelFolder: '確定要刪除該文件夾嗎?',
    sureDelFile: '確定要刪除該文件夾嗎?',
    fileName: '文件名稱',
    fileType: '文件類型',
    fileSize: '文件大小',
    uploadPeople: '上傳人',
    uploadTime: '上傳時間',
    shareMemberIsNotEmpty: '分享成員不能為空',
    selectActivityArea: '請選擇活動區域',
    workflowDescription: '工作流描述',
    triggerThisWorkflow: '操作以下動作會觸發這個工作流',
    whenZhixingRule: '妳想在何時執行此規則?',
    condition: '條件',
    conditionTrigger: '條件決定在什麽情況下觸發規則',
    conditionTriggerNew: '條件決定在什麽情況下觸發規則; 您必須至少指定壹個條件',
    classification: '分類',
    anyCondition: '任何條件',
    matchingCondition: '匹配條件',
    addMatchingCondition: '添加匹配條件',
    selectGroupList: '請選擇分組列表',
    executionOperation: '執行操作',
    addOperation: '添加操作',
    autoAssignTo: '自動分配給',
    autoJumpTo: '自動跳轉到',
    fieldUpdate: '字段更新',
    fieldZhuanhuan: '字段轉換',
    autoFenpei: '自動分配',
    newBuildEmail: '新建郵件',
    newBuildUpdate: '新建與更新',
    noticeRemind: '通知提醒',
    newBuildTask: '新建任務',
    editTask: '編輯任務',
    newBuildUpdateTarget: '新建與更新事件',
    modulesToUpdate: '要更新的模塊',
    fieldsToUpdate: '要更新的字段',
    updateToValue: '更新為值',
    constField: '常量字段',
    qutoeField: '引用字段',
    assignor: '被分配人',
    depMemRole: '成員，部門，角色，可多選',
    addMember: '添加成員',
    allocationMechanism: '分配機制',
    polling: '輪詢',
    random: '隨機',
    insertField: '插入字段',
    haveHandInput: '可手動輸入',
    remindUser: '提醒用戶',
    remindContent: '提醒內容',
    inputMaxlength1000: '請輸入內容,限制1000個字',
    higthContionSetting: '高級條件設置',
    selectClass: '選擇分類',
    selectMoudle: '請選擇模塊',
    inputRuleName: '請填寫規則名稱',
    RuleNameCunzai: '規則名稱已存在',
    selectOnemoudle: '請選擇壹個模塊',
    updateFiledNotEmpty: '要更新的字段不能為空',
    updateTo: '更新為',
    setExecutionOperation: '請設置執行操作',
    operationDelsetIsgoon: '此操作將永久刪除該設置, 是否繼續?',
    all: '全部',
    taskCustom: '任務自定義',
    projectTaskImport1: '請按照數據模版的格式準備要導入的數據',
    projectTaskImport2: '註意事項：模版中的表頭名稱不可更改，表頭行不能刪除',
    projectTaskImport3: '下載數據導入模版',
    projectTaskImport4: '選擇需要導入的數據模版',
    projectTaskImport5:
      '數據模版中，表頭字段名稱需與系統保持壹致，單次導入行數不得超過10000行，超出請分批導入',
    selectFile: '選擇文件',
    customSort: '自定義排序',
    createTimeAse: '創建時間升序',
    createTimeDese: '創建時間降序',
    editTimeAse: '修改時間升序',
    editTimeDese: '修改時間降序',
    view: '視圖',
    todayTask: '今天任務',
    tomorrowTask: '明天任務',
    planTask: '計劃任務',
    allMemberSee: '所有成員可見',
    importDataComplete: '導入數據完成',
    setRepeat: '設置重復',
    addCollaborator: '添加協作人',
    delCollaborator: '移除協作人',
    addSubTask1: '新增子任務',
    editSubTask: '編輯子任務',
    delSubTask: '刪除子任務',
    onlyCollaboratorShow: '僅協作人可見',
    fieldNameIsnotEmpty: '字段名稱不能為空',
    atLeastoneValue: '至少需要存在壹個選項值',
    numberRuleIsnotEmpty: '編號規則不能為空',
    formulaIsnotEmpty: '計算公式不能為空',
    errorSelectExcel: '上傳有誤，請選擇Excel格式文件',
    pleaseUploadTemplate: '請上傳模版文件',
    pleaseInputReason: '請填寫原因',
    secondAfter: '次後',
    projectAuth: '項目權限',
    projectRoleAuth: '項目角色權限',
    projectRoleAuthInfo: '為項目成員在項目中處於不同角色所需的權限設置匹配的項目、任務的操作權限',
    addRoleAuth: '添加角色權限',
    projectRole: '項目角色',
    roleDesc: '角色描述',
    uodateMember: '更新人員',
    updateTiem: '更新時間',
    roleName: '角色名稱',
    authSet: '權限配置',
    projectTagManage: '為項目任務通過標簽進行有效的管理',
    editTag: '編輯標簽',
    addTag1: '新增標簽',
    inputTagName: '請輸入標簽名字',
    selectColor: '選擇顏色',
    editClass: '編輯分類',
    addClass: '添加分類',
    taskAuto: '任務自動化',
    sureDelTag: '確定要刪除該標簽嗎?',
    sureDelClass: '確定要刪除該分類嗎?',
    editRoleAuth: '編輯角色權限',
    roleNameNotEmpty: '角色名稱不能為空',
    addRoleSuccess: '新增角色成功',
    sureDelRole: '您確定刪除該角色?',
    addSubclassSuccess: '新增子分類成功',
    projectTagNotEmpty: '項目標簽名不能為空',
    taskWorkautoInfo: '滿足條件的記錄自動執行設定的業務流程',
    repeatSetting: '重復設置',
    remind: '提醒',
    taskDeadline: '任務截止前',
    delSetting: '刪除設置',
    neverGameover: '永不結束',
    targetTime: '觸發時間',
    managementGroup: '管理分組',
    inspection: '檢驗',
    surveyor: '檢驗人',
    addChecker: '添加檢驗人',
    saveAndAdd: '保存並新增',
    taskName500Words: '任務名稱為必填，且不能超過500個字',
    taskStartEndTimeInfo: '任務開始時間必須小於截止時間',
    haveFillInNot: '有必填項未填寫',
    SaveProjectTemplate: '保存為項目模版',
    wechatWork: '企業微信',
    dingTalk: '釘釘',
    WeChatOfficialAccount: '微信公眾號',
    // 20210305
    selectproject: '選擇項目',
    tasktag: '任務標簽'
  }
}
